export const DEFAULT_PAGE_SIZE = 20;
export const PRAISE_NOTIFICATION_ACTION_TEXT = ' praised you';
export const ENDORSEMENT_NOTIFICATION_ACTION_TEXT = ' endorsed you for ';
export const ORGANIZATION_EVENT_ACTION_TEXT = ' added you as an Organizer for ';
export const LIKE_ACTION_TEXT = ' liked ';
export const COMMENT_ACTION_TEXT = ' commented on ';
export const NOTIFICATION_HISTORY_DAY_COUNT = 30;
